import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-list",
  "use": "icon-list-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-list\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.3449 2.24996C12.1496 2.0547 11.8331 2.0547 11.6378 2.24996L2.35356 11.5342C2.03874 11.849 2.26142 12.3873 2.70665 12.3878L4.50112 12.3894V20.8964C4.50112 21.4487 4.94884 21.8964 5.50112 21.8964H9.50112V16.8964H12.5011V21.8964H18.5011C19.0534 21.8964 19.5011 21.4487 19.5011 20.8964V12.4034L21.2924 12.4051C21.7381 12.4055 21.9616 11.8666 21.6464 11.5515L12.3449 2.24996Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol